<template>
  <div data-server-rendered="true" id="__nuxt" class="bannerBox">
    <!---->
    <div id="__layout">
      <div id="body">
        <div class="index_body">
          <div class="head_height">
            <div class="banner_box">
              <div class="banner page_width">
                <div class="ban_top">
                  <div class="logo"></div>
                  <div class="right flex">
                    <div class="no_login" v-if="!loginTrue" @click="loginUp()">
                      登录/注册
                    </div>
                    <!--                    <div class="no_loginLeft" @click="myInformation" v-else>-->
                    <!--                      <span>我的</span>-->
                    <!--                    </div>-->
                    <div class="no_loginRight" v-if="loginTrue">
                      <span class="logout" @click="logout" v-if="loginTrue"
                      >退出</span
                      >
                    </div>
                  </div>
                </div>
                <div class="ban_btn"></div>
              </div>
            </div>
          </div>

          <div class="bord" v-if="hisShow">
            <!-- 顶部横幅说明 -->
            <div class="header-banner">
              <div class="banner-title">基于先进人工智能技术，快速评估企业科创能力，提供数据驱动的优化建议，助力企业创新发展和新质生产力提升。通过智能算法分析，为企业提供个性化科创发展路径规划。</div>
            </div>

            <div class="main-content" v-if="!textShow && !isLoading">
              <!-- 评估说明与优势（上方展示） -->
              <div class="right-section top-description">
                <div class="section-header">
                  <div class="header-icon dark-blue"></div>
                  <h2 class="section-title">评估说明与优势</h2>
                </div>

                <div class="description-content">
                  <p class="desc-text">
                    本系统采用<span class="highlight">先进的人工智能算法</span>，通过分析企业核心数据，评估科创能力水平，为企业提供科学、精准的发展建议。
                  </p>

                  <!-- 评估适用对象 -->
                  <div class="usage-section">
                    <h3 class="usage-title">适用企业场景</h3>
                    <div class="usage-grid">
                      <div class="usage-item">
                        <h4>成长型中小企业</h4>
                        <p>正在布局研发体系、希望理清自身技术优势与短板、匹配产业政策与资源的企业。</p>
                      </div>
                      <div class="usage-item">
                        <h4>高新技术与专精特新企业</h4>
                        <p>需要系统梳理知识产权、研发投入产出，支撑申报认定、融资路演等关键环节。</p>
                      </div>
                      <div class="usage-item">
                        <h4>传统产业转型升级企业</h4>
                        <p>希望通过数字化、智能化、绿色化改造，寻找第二增长曲线的制造业与服务业企业。</p>
                      </div>
                    </div>
                  </div>

                  <div class="advantage-list">
                    <div class="advantage-item">
                      <div class="adv-icon-wrapper ai">
                        <i class="el-icon-cpu"></i>
                      </div>
                      <span>AI智能分析，精准评估科创能力</span>
                    </div>
                    <div class="advantage-item">
                      <div class="adv-icon-wrapper dimension">
                        <i class="el-icon-menu"></i>
                      </div>
                      <span>多维度分析，全面了解企业现状</span>
                    </div>
                    <div class="advantage-item">
                      <div class="adv-icon-wrapper industry">
                        <i class="el-icon-office-building"></i>
                      </div>
                      <span>行业对标，定位企业发展水平</span>
                    </div>
                    <div class="advantage-item">
                      <div class="adv-icon-wrapper path">
                        <i class="el-icon-map-location"></i>
                      </div>
                      <span>发展路径规划，明确未来方向</span>
                    </div>
                    <div class="advantage-item">
                      <div class="adv-icon-wrapper resource">
                        <i class="el-icon-set-up"></i>
                      </div>
                      <span>资源配置优化，提升创新效率</span>
                    </div>
                    <div class="advantage-item">
                      <div class="adv-icon-wrapper report">
                        <i class="el-icon-document-checked"></i>
                      </div>
                      <span>详细分析报告，数据驱动决策</span>
                    </div>
                  </div>

                  <div class="report-info">
                    <p>评估完成后，您将获得一份详细的<span class="highlight-blue">科创能力分析报告</span>，包括数据分析、行业对比、改进建议等内容，帮助企业优化创新资源配置，提升核心竞争力。</p>
                  </div>

                  <div class="security-notice">
                    <p>您的数据安全是我们的首要任务。所有数据均采用企业级加密等级存储，严格保密，仅用于科创能力分析。我们承诺绝不泄露任何企业数据。</p>
                  </div>

                  <!-- 评估流程简要说明 -->
                  <div class="workflow-section">
                    <h3 class="workflow-title">评估流程一览</h3>
                    <div class="workflow-steps">
                      <div class="workflow-step">
                        <span class="step-index">01</span>
                        <div class="step-content">
                          <h4>填写基础信息</h4>
                          <p>输入公司名称、人员规模、主营收入及研发投入等基础数据。</p>
                        </div>
                      </div>
                      <div class="workflow-step">
                        <span class="step-index">02</span>
                        <div class="step-content">
                          <h4>智能数据检索</h4>
                          <p>系统自动检索企业公开数据，补充知识产权、荣誉奖项等信息。</p>
                        </div>
                      </div>
                      <div class="workflow-step">
                        <span class="step-index">03</span>
                        <div class="step-content">
                          <h4>生成可视化报告</h4>
                          <p>从行业方向、投入产出、创新能力等多个维度生成可视化分析报告。</p>
                        </div>
                      </div>
                      <div class="workflow-step">
                        <span class="step-index">04</span>
                        <div class="step-content">
                          <h4>获取优化建议</h4>
                          <p>针对关键短板与潜力方向，给出可落地的提升路径与资源配置建议。</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 科创能力评估表单（下方展示） -->
              <div class="left-section">
                <div class="section-header">
                  <div class="header-icon blue"></div>
                  <h2 class="section-title">科创能力评估</h2>
                </div>

                <div class="form-tip">
                  请尽量填写<span>真实、完整</span>的企业信息，系统将基于公开数据和您提供的数据进行综合评估。
                </div>

                <div class="form-row">
                  <el-form
                    ref="form"
                    :model="sizeForm"
                    label-position="left"
                    label-width="100px"
                    size="medium"
                    class="formClass"
                  >
                    <el-form-item label="公司名称：">
                      <el-input
                        v-model="sizeForm.companyName"
                        placeholder="请输入公司全称"
                        prefix-icon="el-icon-office-building"
                      />
                    </el-form-item>
                    <el-form-item label="人员规模：">
                      <el-input
                        type="number"
                        v-model="sizeForm.staffSize"
                        placeholder="请输入人员规模"
                        prefix-icon="el-icon-user"
                      >
                        <template slot="append">人</template>
                      </el-input>
                    </el-form-item>
                    <el-form-item label="研发人员：">
                      <el-input
                        type="number"
                        v-model="sizeForm.personnel"
                        placeholder="请输入研发人员数量"
                        prefix-icon="el-icon-user-solid"
                      >
                        <template slot="append">人</template>
                      </el-input>
                    </el-form-item>
                    <el-form-item label="主营收入：">
                      <el-input
                        type="number"
                        v-model="sizeForm.mainOperatingIncome"
                        placeholder="请输入主营收入"
                        prefix-icon="el-icon-money"
                      >
                        <template slot="append">万元</template>
                      </el-input>
                    </el-form-item>
                    <el-form-item label="研发投入：">
                      <el-input
                        type="number"
                        v-model="sizeForm.investment"
                        placeholder="请输入研发投入"
                        prefix-icon="el-icon-coin"
                      >
                        <template slot="append">万元</template>
                      </el-input>
                    </el-form-item>
                  </el-form>
                </div>

                <el-button
                  class="queryButton"
                  type="primary"
                  @click="send"
                >
                  <i class="el-icon-search"></i>
                  立即智能分析
                </el-button>
              </div>
            </div>

            <!--生成公司信息-->
            <div id="app" v-if="textShow" ref="messageContainer">
              <AdaptiveIframe
                :src="htmlUrl"
                custom-class="concept-iframe"
                :min-height="500"
                :height-margin="0"
                :retry-count="1"
                :retry-interval="1000"
              />
              <button class="refreshPageClass" @click="refreshPage">
                <span>重新查询</span>
              </button>
            </div>

            <!--加载中的遮罩-->
            <div v-if="isLoading">
              <div class="loadingGif fade-in">
                <loading/>
                <div style="margin-top: 16px;font-size: 24px">报告生成中...</div>
                <div style="margin-top: 16px;font-size: 24px">该模型包含数据查询、复杂逻辑推导、界面图形生成，请耐心等待1-2分钟</div>
              </div>
            </div>
          </div>
          <!---下面背景图 -->
          <div style="background: #252525">
            <img
                src="../assets/img/c02ddf2d50ba0a9c37c54f6b278d02a.png"
                alt
                class="foot_bg"
            />
            <div class="website">
              <div class="max_wid">
                <div class="max_lef">
                  <!--                  <div class="labe2">版权所有：泰安市科学技术局</div>-->
                  <div class="labe2">
                    通讯地址：泰安市高新区正阳门大街28号国家高创中心西塔422号
                  </div>
                  <div class="classLabe2">
                    <div class="labe2Left">
                      主办单位：泰山科技大市场
                      <span class="view-count-inline">
                        <i class="el-icon-view"></i>
                        <span>{{ viewCount }} 浏览</span>
                      </span>
                    </div>
                    <div class="labe2Right">技术支持：0538-8265266</div>
                  </div>
                </div>
                <div class="max_rig">
                  <!--              <div class="label">服务电话：</div>-->
                  <div class="labe2">联系方式：18953878448</div>
                  <div class="labe2">邮编：271000</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PersonalInformation from "./PersonalInformation .vue";
import InformationAdmin from "@/views/InformationAdmin.vue";
import PersonalFrom from "@/views/PersonalFrom.vue";
import unionFrom from "@/views/unionFrom.vue";
import HistoricalRecords from "@/views/historicalRecords.vue";
import {getApi, getToken, knowledge, visit} from "@/api/http";
import {changeStatus} from "@/api/login";
import axios from "axios";
import {getHtml, addFormRecord, editFormRecord} from "@/api/concept";
import AdaptiveIframe from "@/components/AdaptiveIframe.vue";
import loading from "@/components/loading.vue";

export default {
  components: {
    HistoricalRecords,
    PersonalFrom,
    unionFrom,
    xinxi: PersonalInformation,
    InformationAdmin,
    AdaptiveIframe,
    loading
  },
  data() {
    return {
      viewCount: 0,
      htmlUrl: "",
      url: "wss://kejichengguo.tskjdsc.com/websocket/message",
      // url: "ws://localhost:8945/websocket/message",
      message: " ",
      text_content: "",
      ws: null,
      sizeForm: {
        companyName: "", //公司名
        staffSize: "", //人员规模
        personnel: "", //研发人员
        mainOperatingIncome: "", //主营业收入
        investment: "", //研发投入
      },
      rawData: "", // 用于存储从API获取的完整数据
      parts: [], // 用于逐步显示的数据
      //展示数据
      textShow: false,
      //加载中
      isLoading: false,
      hisShow: true,
      loginTrue: "", //是否登录
      companyName: "",
      // text: "{\n    1. **企业概况**：\n        - 石横特钢集团有限公司（简称“石横特钢”）是一家集焦化、炼铁、炼钢、轧钢、发电、机械制造、民间资本、钢铁物流于一体的大型钢铁联合企业，总部位于泰安肥城市石横镇。\n        - 公司主营业务涵盖钢铁生产及其相关领域，产品体系完备，包括建筑钢材、板材、矿用支护用钢、电力角钢等专业领域产品，以及高强度合金钢、耐蚀钢、耐低温钢等发展方向产品。\n\n    2. **行业地位**：\n        - 石横特钢综合经济实力连续多年跻身中国企业500强、中国企业集团纳税500强之列。\n        - 公司被工信部认定为绿色工厂，被科技部认定为高新技术企业，在中国钢铁企业综合竞争力评级中连续多年获评特强A级。\n        - 石横特钢还荣获了国家智能制造示范工厂、国家企业技术中心、山东省和谐劳动关系优秀企业、山东省节能先进企业、山东省循环经济示范企业等一系列荣誉称号。\n\n    3. **掌握技术**：\n        - 石横特钢拥有先进的钢铁生产技术，包括高炉炼铁、转炉炼钢、轧钢等生产线，以及从美国摩根公司和意大利引进的先进生产线。\n        - 公司在生产过程中注重技术创新和精细化管理，不断提升产品质量和生产效率。\n        - 公司在环保方面也取得了显著成果，如采用先进的废气治理设施和水循环利用系统，实现了固体废物100%综合利用合规处置，水循环利用率达到97.5%以上。\n\n    4. **知识产权**：\n        - 实时搜索查询显示，石横特钢拥有一定数量的专利和软件著作权。但具体数量可能因时间变化而有所不同，建议直接访问国家知识产权局官网或公司官网进行查询。\n\n    5. **科创评分**：\n        - 从技术质量来看，石横特钢的产品质量稳定，多次获得国家和省级荣誉，可以给予18分。\n        - 从技术规模来看，公司拥有完整的钢铁生产流程和先进的生产设备，规模较大，给予19分。\n        - 从研发实力来看，公司注重技术创新和研发投入，拥有多项专利和荣誉，给予18分。\n        - 从成长性来看，公司连续多年保持稳健发展，综合实力不断提升，给予17分。\n        - 从行业潜力来看，钢铁行业仍有发展空间，且石横特钢在行业内处于领先地位，给予16分。\n        - 总分：18+19+18+17+16=98分，评级别为A级（优秀）。\n\n    6. **行业发展方向**：\n        - 石横特钢应继续加强在优质精品钢生产领域的投入，提升产品附加值和市场竞争力。\n        - 拓展新能源和环保产业，如利用余热发电、开发低碳排放技术等，以适应国家绿色发展的要求。\n        - 深化数字化转型，提升生产效率和智能化水平，降低运营成本。\n\n    7. **技术需求挖掘**：\n        - 在产业升级方面，石横特钢需要引进更先进的生产技术和管理模式，提升产品质量和生产效率。\n        - 在降低成本方面，公司需要研发更高效的能源利用技术和废弃物回收技术，降低生产成本和环境负担。\n        - 具有前瞻性的创新技术需求包括开发新型高性能钢材、优化生产工艺流程、提升智能化和自动化水平等。\n\n    8. **技术转移对接**：\n        - 对于先进的生产技术和管理模式，石横特钢可以与国内外知名的钢铁企业和研究机构进行合作，引进先进技术和管理经验。\n        - 在新能源和环保技术方面，可以与山东省内重点高校如山东大学、中国海洋大学等进行合作研发。\n        - 在数字化转型方面，可以与山东省内的IT企业和研究机构进行合作，共同开发适用于钢铁行业的智能化和自动化技术。\n}\n\n以上信息仅供参考，如需更详细和准确的信息，建议直接访问石横特钢集团有限公司的官网或联系公司相关部门。}",
      text: "",
      keywords: ["企业概况"],
      output: "",
      token: "",
    };
  },
  mounted() {
    this.initViewCount();
  },
  created() {
    this.getToken();
    this.login();
  },

  methods: {


    async initViewCount() {
      const pageKey = this.$route?.path || 'ZhiqiTong';
      try {
        const res = await visit({ pageKey });
        const data = res && res.data !== undefined ? res.data : res;
        if (data && (data.code === 200 || data.code === 0)) {
          this.viewCount = data.data;
        } else if (typeof data === 'number') {
          this.viewCount = data;
        } else if (data && typeof data.data === 'number') {
          this.viewCount = data.data;
        }
      } catch (e) {
        console.error('浏览量上报失败', e);
      }
    },
    //重新查看
    refreshPage() {
      window.location.reload();
    },

    changeStatus() {
      const controller = new AbortController();
      this.textShow = false;
      this.output = "";
    },

    join() {
      const wsuri = this.url;
      this.ws = new WebSocket(wsuri);
      const self = this;
      this.ws.onopen = function (event) {
        self.text_content = self.text_content + "已经打开连接!" + "\n";
      };

      this.ws.onmessage = function (event) {
        if (self.output === "正在生成,请稍等........") {
          self.output = "";
        }
        self.output += event.data
            .replaceAll("^\\{|\\}$", "")
            .replace("{", "")
            .replace("}", "")
            .replace('"', "");
      };
      this.ws.onclose = function (event) {
        self.text_content = self.text_content + "已经关闭连接!";
      };

      // 滚动到底部
      const outputEl = document.getElementById("text"); // 替换为您的容器ID
      outputEl.scrollTop = outputEl.scrollHeight;
    },

    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.messageContainer;
        container.scrollTop = container.scrollHeight;
      });
    },

    exit() {
      if (this.ws) {
        this.ws.close();
        this.ws = null;
      }
    },
    send() {
      const token = localStorage.getItem("token");
      if (token == null) {
        this.$message({
          message: "您当前未登录账号，请登录或注册账号后进行查询",
          type: "error",
          duration: 5000,
          showClose: true,
          offset: 200,
        });
      } else {
        this.message =
                "请基于公开数据生成《"+ this.sizeForm.companyName +"企业科创实力分析报告》，要求如下：\n\n" +
                "一、数据整合"
                + "行业分类：[自动识别]\n"+
                "人员：总规模"+ this.sizeForm.staffSize +"人\n" +
                "研发"+ this.sizeForm.personnel +"人\n" +
                "财务：营收"+ this.sizeForm.mainOperatingIncome +"万元，\n" +
                "研发投入"+ this.sizeForm.investment +"万元\n" +
                "知识产权：专利/软著数量[自动检索]\n" +
                "荣誉：[自动检索近3年核心奖项]\n" +
                "二、分析维度（用图表+文字）\n" +
                "行业方向：技术领域分布雷达图营收与研发：双轴折线图（营收vs研发投入）\n" +
                "研发人员：知识产权：专利类型占比表（如果查不到数据可以不展示可视化图表）" +
                "荣誉：时间轴展示\n" +
                "三、建议维度针对以上5项分析，分别给出1-2条改进建议\n" +
                "四、设计要求\n" +
                "如果没有数据支撑可以不需要生成图\n"+
                "如何查不到数据，可以通过表格来拼凑,\n"+
                "宽度1200px居中，主题色#2A5CAA\n" +
                "图表高度≤300px，优先SVG,仅使用原生SVG/Canvas/D3.js（基础版）绘制图表（禁止使用ECharts/Chart.js等第三方库）\n"+
                "关键数据加粗变色,\n" +
                "不要出现数据来源：企查查、爱企查、政府公共数据平台等字段\n" +
                "交付完整HTML文件。\n" +
                "每个模块都要严格分明不要出现占据在一块得情况。\n"+
                "不得出现复杂的可视化图表,不要体现生成时间\n"

            // "根据企查查、爱企查，结合政府公共数据，查下" +
            // this.sizeForm.companyName +
            // "，这个公司主要的行业是什么，知识产权专利和软著分别有多少，" +
            // "获得荣誉有哪些,公司人员规模" +
            // this.sizeForm.staffSize +
            // "人，" +
            // "研发人员" +
            // this.sizeForm.personnel +
            // "人，" + "，去年主营业收入" +
            // this.sizeForm.mainOperatingIncome +
            // "万元" +
            // "和研发投入" +
            // this.sizeForm.investment +
            // "万元，" +
            // "根据以上信息，分别从行业方向，营业收入和研发投入，" +
            // "研发人员，知识产权，获得荣誉这六个维度的分析下企业的科创情况。" +
            // "并从企业科创如何做得更好的角度，分别从1.技术需求 、2.营业收入 、3.研发投入，4.研发人员，5.知识产权，" +
            // "6.获得荣誉这六个维度给出合理有效的建议。" +
            // "按照以上内容生成结果，不要出现企查查等一些字眼，要求返回html格式，内容丰富生动，有数据部分适当用柱状图或折线图等简单图表,图表高度、宽度要适应网页大小，高度不超过500px,没数据的就不用图表，不要有外部链接图片，宽度1200居中， 适当用主题色突出标题和重点部分 ，交付：提供完整HTML文件,不需要注释。";
        this.isLoading = true;
        this.textShow = false;

        // 先调用新增记录接口（只需要公司名称和userId）
        const userId = localStorage.getItem("userId");
        addFormRecord({
          companyName: this.sizeForm.companyName,
          userId: userId
        }).then((addResponse) => {
          console.log("新增巡检报告记录成功", addResponse);
          const recordId = addResponse && (addResponse.data?.id || addResponse.id);
          console.log("获取到的recordId:", recordId);

          // 继续执行查询
          getHtml({concat: this.message.replaceAll("%", ""),stream:"false"}).then((res) => {
            if (res.code === 200) {
              this.htmlUrl = res.data;
              this.isLoading = false;
              this.textShow = true;

              // 数据加载完成后，调用更新记录接口
              if (recordId) {
                editFormRecord({
                  id: recordId,
                  responseTime: new Date().getTime()
                }).then((editResponse) => {
                  console.log("更新巡检报告记录响应:", editResponse);
                }).catch((editError) => {
                  console.error("更新巡检报告记录失败", editError);
                });
              }
            } else {
              this.$message({
                message: '请求失败',
                type: "error",
              });
            }
          });
        }).catch((addError) => {
          console.error("新增巡检报告记录失败", addError);
          // 即使新增记录失败，也继续执行查询
          getHtml({concat: this.message.replaceAll("%", "")}).then((res) => {
            if (res.code === 200) {
              this.htmlUrl = res.data;
              this.isLoading = false;
              this.textShow = true;
            } else {
              this.$message({
                message: '请求失败',
                type: "error",
              });
            }
          });
        });
      }
    },

    //登录接口
    login() {
      const token = localStorage.getItem("token");
      if (token == null) {
        this.$message({
          message: "您当前未登录账号，请登录或注册账号后进行查询",
          type: "error",
          duration: 5000,
          showClose: true,
          offset: 200,
        });
      }
    },

    hisShowChange() {
      this.hisShow = false;
    },
    //跳转登录
    loginUp() {
      this.$router.push({path: "/login", query: {type: "4"}});
    },

    logout() {
      console.log("go");
      sessionStorage.clear();
      localStorage.clear();
      this.loginTrue = true;
      this.$router.push({path: "/login", query: {type: "4"}});

    },

    getToken() {
      if (localStorage.getItem("token")) {
        this.loginTrue = true;
        this.showPage = true;
      } else {
        this.loginTrue = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.fade-in {
  animation: fadeIn 0.8s ease-in-out forwards;
  opacity: 0;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.loadingGif {
  width: 100%;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.classLabe2 {
  display: flex;

  .labe2Right {
    margin-left: 270px;
  }
}

.form-row {
  .formClass {
    font-size: 24px;

    .InputNumberClass {
      width: 80%;
    }
  }
}

::v-deep .el-form-item__label {
  font-size: 24px;
}

::v-deep .el-input__inner {
  font-size: 24px;
}

::v-deep .bold-title {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 10px !important;
}

//加载中
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 半透明黑色背景 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* 遮罩层在最上面 */
}

.loading-spinner {
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid #0077ff;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

/* 加载动画 */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 加载文本样式 */
.loading-text {
  color: #ffffff;
  margin-top: 20px;
  font-size: 22px;
  text-align: center;
}

//数据处理样式
.content {
  white-space: pre-line; /* 保留换行符 */
  text-align: left;
  font-size: 24px;
}

::v-deep .refreshPageClass {
  font-size: 24px;
  margin-top: 30px;
  border-radius: 10px;
  width: 200px;
  height: 40px;
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
}

.queryButton {
  width: 200px;
  font-size: 24px;
  margin-top: 30px;
  margin-left: 200px;
}

//.form-row {
//  display: flex;
//  align-items: center;
//  width: 80%;
//}

//.form-row span {
//  margin-right: 10px;
//  width: 20%;
//}

.notice {
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 40px;
  font-size: 24px;
}

.selectedForm {
  width: 200px;
}

.formSelectDiv {
  font-size: 24px;
  text-align: center;
  margin-bottom: 20px;
}

.label {
  margin-right: 10px; /* 控制文本和选择框之间的间距 */
}

.selectClass {
  padding: 5px;
  border: 1px solid #ccc;
  width: 500px;
  font-size: 24px;
}

.bord {
  margin: 90px auto 120px;
  padding: 20px;
  max-width: 1200px;
  min-height: 300px;
  height: auto;
  border: 2px solid #ffffff;
  text-align: center;
  transition: all 0.3s ease;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

// 顶部横幅样式
.header-banner {
  background: linear-gradient(135deg, #2A5CAA 0%, #3A7BC8 100%);
  border-radius: 8px;
  padding: 24px 32px;
  margin-bottom: 30px;
  color: white;
  text-align: center;

  .banner-title {
    font-size: 22px;
    line-height: 1.6;
    margin: 0;
    font-weight: 400;
  }
}

// 主内容区域
.main-content {
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: stretch;
}

// 左侧表单区域 & 右侧说明区域卡片样式
.left-section,
.right-section {
  flex: 1;
  min-width: 0;
  background: #fafbfc;
  border-radius: 8px;
  padding: 24px 28px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid #f0f2f5;
}

.top-description {
  background: #ffffff;
}

// 区域头部样式
.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 24px;

  .header-icon {
    width: 6px;
    height: 24px;
    margin-right: 12px;
    border-radius: 3px;

    &.blue {
      background-color: #2A5CAA;
    }

    &.dark-blue {
      background-color: #1A4A7A;
    }
  }

  .section-title {
    font-size: 24px;
    font-weight: 600;
    color: #333;
    margin: 0;
  }
}

// 表单样式优化
.form-row {
  .formClass {
    .el-form-item {
      margin-bottom: 20px;

      .el-form-item__label {
        font-size: 18px;
        color: #333;
        font-weight: 500;
        padding-right: 15px;
        line-height: 40px;
      }

      .el-form-item__content {
        .el-input {
          .el-input__inner {
            height: 40px;
            border-radius: 4px;
            font-size: 17px;
          }
        }
      }
    }
  }
}

.form-tip {
  font-size: 17px;
  color: #666;
  background: #f8f9ff;
  border-radius: 6px;
  padding: 10px 14px;
  margin-bottom: 18px;

  span {
    color: #2A5CAA;
    font-weight: 600;
  }
}

// 覆盖element-ui默认样式确保标签不换行
::v-deep .el-form-item__label {
  white-space: nowrap !important;
  overflow: visible !important;
}

::v-deep .el-form-item {
  display: flex !important;
  align-items: center !important;
}

::v-deep .el-form-item__content {
  flex: 1;
  margin-left: 0 !important;
}

// 按钮样式
.queryButton {
  width: 200px;
  font-size: 24px;
  margin-top: 20px;
  height: 44px;
  border-radius: 6px;
  background: linear-gradient(135deg, #2A5CAA 0%, #3A7BC8 100%);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-left: 40%;
  i {
    font-size: 24px;
  }

  &:hover {
    background: linear-gradient(135deg, #3A7BC8 0%, #4A8BD8 100%);
  }
}

// 右侧说明内容样式
.description-content {
  .desc-text {
    font-size: 24px;
    line-height: 1.6;
    color: #666;
    margin-bottom: 24px;

    .highlight {
      color: #2A5CAA;
      font-weight: 600;
    }
  }

  .advantage-list {
    margin-bottom: 24px;

    .advantage-item {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      padding: 12px 16px;
      background: #fafbfc;
      border-radius: 8px;
      border: 1px solid #f0f2f5;
      transition: all 0.3s ease;

      &:hover {
        background: #f8f9ff;
        border-color: #e8ecff;
        transform: translateX(4px);
      }

      .adv-icon-wrapper {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 12px;
        flex-shrink: 0;

        &.ai {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          i {
            color: white;
            font-size: 22px;
          }
        }

        &.dimension {
          background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
          i {
            color: white;
            font-size: 22px;
          }
        }

        &.industry {
          background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
          i {
            color: white;
            font-size: 22px;
          }
        }

        &.path {
          background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
          i {
            color: white;
            font-size: 22px;
          }
        }

        &.resource {
          background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
          i {
            color: white;
            font-size: 22px;
          }
        }

        &.report {
          background: linear-gradient(135deg, #a8edea 0%, #fed6e3 100%);
          i {
            color: white;
            font-size: 22px;
          }
        }
      }

      span {
        font-size: 18px;
        color: #555;
        line-height: 1.5;
        font-weight: 500;
      }
    }
  }

  .report-info {
    background: #f8f9ff;
    border: 1px solid #e8ecff;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 20px;

    p {
      font-size: 18px;
      line-height: 1.6;
      color: #555;
      margin: 0;

      .highlight-blue {
        color: #2A5CAA;
        font-weight: 600;
      }
    }
  }

  .security-notice {
    background: #fff7f0;
    border: 1px solid #ffe4cc;
    border-radius: 8px;
    padding: 16px;

    p {
      font-size: 17px;
      line-height: 1.5;
      color: #8b4513;
      margin: 0;
    }
  }

  // 使用场景
  .usage-section {
    margin: 24px 0;

    .usage-title {
      font-size: 24px;
      font-weight: 600;
      color: #333;
      margin-bottom: 12px;
    }

    .usage-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 16px;

      .usage-item {
        background: #ffffff;
        border-radius: 8px;
        border: 1px solid #f0f2f5;
        padding: 12px 14px;
        text-align: left;

        h4 {
          font-size: 17px;
          color: #2A5CAA;
          margin: 0 0 6px;
        }

        p {
          font-size: 16px;
          color: #666;
          margin: 0;
          line-height: 1.6;
        }
      }
    }
  }

  // 评估流程
  .workflow-section {
    margin-top: 24px;
    border-top: 1px dashed #e4e7ed;
    padding-top: 18px;

    .workflow-title {
      font-size: 24px;
      font-weight: 600;
      color: #333;
      margin-bottom: 12px;
    }

    .workflow-steps {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 20px 32px;

      .workflow-step {
        display: flex;
        align-items: flex-start;
        gap: 16px;

        .step-index {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: #2A5CAA;
          color: #fff;
          font-size: 18px;
          font-weight: 600;
          flex-shrink: 0;
          margin-top: 2px;
        }

        .step-content {
          flex: 1;

          h4 {
            font-size: 18px;
            color: #333;
            margin: 0 0 6px;
            font-weight: 600;
            line-height: 1.4;
          }

          p {
            font-size: 16px;
            color: #666;
            margin: 0;
            line-height: 1.6;
          }
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .main-content {
    flex-direction: column;
    gap: 20px;
  }

  .header-banner {
    padding: 16px 20px;

    .banner-title {
      font-size: 24px;
    }
  }

  .section-title {
    font-size: 24px !important;
  }

  .form-row .formClass {
    font-size: 17px;
  }

  .description-content {
    .desc-text {
      font-size: 17px;
    }

    .advantage-item span {
      font-size: 17px;
    }

    .report-info p {
      font-size: 17px;
    }

    .security-notice p {
      font-size: 16px;
    }
  }
}

::v-deep .subClass {
  color: #fff !important;
  background-color: #0077ff !important;
}

.closeClass {
  color: #fff;
  background-color: #ff4d4f;
}

.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: center;
}

.clickable {
  color: #0077ff;
  cursor: pointer;
  //text-decoration: underline;
}

.bannerBox {
  width: 100%;
}

.layout {
  width: 100%;
}

::v-deep .layout {
  display: flex;
}

.banner_box {
  height: 500px;
}

.banner_box .ban_top .right .no_login {
  cursor: pointer;
  background: #e4e7ed;
  border-radius: 24px;
  font-size: 24px;
  color: #303133;
  line-height: 23px;
  padding: 12px 22px;
  margin-bottom: 30px;
}

.banner_box .ban_top .left img {
  width: 176px;
}

.img {
  max-width: 100%;
  border: none;
}

.banner_box .ban_top .left .div2 {
  position: relative;
  margin: 0 40px 0 80px;
  padding: 12px 20px;
  border-radius: 23px;
}

.banner_box {
  background-image: url("~@/assets/img/zijian.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 24px 0 190px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-content: space-around;
}

.banner_box .ban_top .left .div1,
.banner_box .ban_top .left .div2 {
  font-weight: 400;
  font-size: 15px;
  color: #fff;
  line-height: 20px;
}

.banner_box .ban_top .left .div1,
.banner_box .ban_top .left .div2 {
  font-weight: 400;
  font-size: 15px;
  color: #fff;
  line-height: 20px;
}

.banner_box .ban_top {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
}

.banner_box .ban_text {
  margin: 100px 0 43px;
  font-weight: 600;
  font-size: 54px;
  color: #fff;
  line-height: 71px;
  text-align: center;
}

.flex {
  display: flex;
  align-items: center;
  flex: none;
}

.banner_box .btn1,
.banner_box .btn2 {
  cursor: pointer;
  padding: 19px 90px;
  font-weight: 400;
  font-size: 22px;
  line-height: 22px;
  margin-right: 50px;
}

.ban_btn {
  margin-top: 410px;
}

.banner_box .ban_btn .btn1 {
  border-radius: 30px;
  border: 2px solid #fff;
  color: #fff;
}

.banner_box .ban_btn .btn2 {
  border-radius: 30px;
  background: #fff;
  color: #333;
}

.banner_box .ban_btn .btn1,
.banner_box .ban_btn .btn2 {
  cursor: pointer;
  padding: 19px 90px;
  font-weight: 400;
  font-size: 22px;
  line-height: 22px;
  margin-right: 50px;
}

.banner_box .ban_btn {
  display: flex;
  align-items: center;
  justify-content: center;
}

.step_box .step,
.step_box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.step_box {
  background: #f7f7f7;
  padding: 90px 0 100px;
}

.step_box .step .step_top {
  font-weight: 700;
  font-size: 32px;
  color: #333;
  line-height: 53px;
}

.step_box .step .step_lab {
  margin-top: 26px;
  font-weight: 400;
  font-size: 24px;
  color: #606266;
  line-height: 27px;
}

.step_box .step .step_itm {
  margin-top: 60px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.page_width {
  width: 1200px;
  margin-top: 100px;
}

.step_box .step {
  flex-direction: column;
}

.step_box .step .step_itm .itm_box .num {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  color: #2238c2;
  width: 76px;
  height: 76px;
  border-radius: 50%;
  border: 2px solid #2238c2;
}

.step_box .step .step_itm .line {
  margin-top: 27px;
  width: 15%;
  height: 2px;
  background: #2238c2;
}

.step_box .step .step_itm .line {
  margin-top: 40px;
  width: 10%;
  height: 2px;
  background: #2238c2;
}

.step_box .step .step_itm .itm_box .span {
  margin-top: 20px;
  font-weight: 500;
  font-size: 24px;
  color: #333;
}

.step_box .step .step_itm .itm_box .span {
  margin-top: 20px;
  font-weight: 500;
  font-size: 24px;
  color: #333;
}

.reason_box {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  padding: 90px 0 120px;
}

.reason_box {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  padding: 90px 0 120px;
}

.reason_box .reason .tit {
  text-align: center;
  font-weight: 700;
  font-size: 32px;
  color: #333;
}

.reason_box .reason .tit {
  text-align: center;
  font-weight: 700;
  font-size: 32px;
  color: #333;
}

.reason_box .reason .tit span {
  color: #2238c2;
}

.reason_box .reason .cont .cont_itm {
  margin-left: 24px;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 385px;
  height: 286px;
  padding: 62px 53px 0;
  box-sizing: border-box;
  background: #f5fbfc;
  border-radius: 12px;
  font-size: 24px;
}

.cont_itmDun {
}

.reason_box .reason .cont {
  margin-top: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.reason_box .reason .cont {
  margin-top: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.exchange_box .exchange .ex_left .tit {
  font-weight: 700;
  font-size: 32px;
  color: #333;
  margin-bottom: 50px;
}

.exchange_box .exchange .ex_left .tit span {
  color: #2238c2;
}

.exchange_box .exchange .ex_left {
  width: 75%;
}

.exchange_box .exchange .ex_left .itm img {
  width: 24px;
  height: 24px;
  margin-right: 14px;
  font-size: 24px;
}

img {
  max-width: 100%;
  border: none;
}

.exchange_box .exchange {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.exchange_box .exchange .ex_left .itm {
  display: flex;
  align-items: flex-start;
  margin-bottom: 24px;
  font-size: 24px;
}

.exchange_box {
  padding: 84px 0 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url("../assets/img/lineImg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.exchange_box .exchange .ex_rig img {
  width: 349px;
}

.exchange_box .exchange .ex_rig img {
  width: 349px;
}

img {
  width: 100%;
  border: none;
}

.exchange_box .exchange {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.exchange_box .exchange {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.website {
  padding: 30px 0;
  background: #252525;
  justify-content: center;
}

.website .max_wid {
  max-width: 1200px;
  width: 100%;
  justify-content: space-around;
  color: #a8a8a8;
  background: #252525;
}

.website,
.website .max_wid {
  display: flex;
  align-items: center;
  line-height: 1.6;
}

.website .max_wid {
  max-width: 1200px;
  width: 100%;
  justify-content: space-around;
}

.website,
.website .max_wid {
  display: flex;
  align-items: center;
}

.website .max_wid {
  max-width: 1200px;
  width: 100%;
  justify-content: space-around;
}

.website,
.website .max_wid {
  display: flex;
  align-items: center;
}

.logo {
  cursor: pointer;
  background-image: url("~@/assets/img/logn.png");
  background-size: 450px 70px;
  width: 450px;
  height: 70px;
  margin-bottom: 25px;
}

.view-count-inline {
  display: inline-flex;
  align-items: center;
  margin-left: 12px;
  padding: 2px 12px;
  border-radius: 20px;
  border: 1px solid #555555;
  background-color: transparent;
  font-size: 14px;
  color: #dcdcdc;

  span {
    display: inline-block;
    line-height: 1;
  }

  i {
    margin-right: 4px;
    font-size: 16px;
    line-height: 1;
    color: #dcdcdc;
  }
}

.problem_box {
  width: 100%;
  background: #fff;
  padding: 90px 0 131px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.problem_box_inline {
  width: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0 131px;
}

.problem_box_inline .pro_tit span {
  color: #009eb8;
}

.problem_box_inline .pro_tit {
  font-weight: 700;
  font-size: 32px;
  color: #333;
  line-height: 53px;
  text-align: center;
  margin-bottom: 80px;
}

.problem_box_inline .pro_lab {
  font-weight: 700;
  margin-bottom: 13px;
  font-size: 24px;
  color: #333;
}

.problem_box_inline .pro_cont {
  font-weight: 400;
  font-size: 24px;
  color: #666;
  line-height: 28px;
}

.mb40 {
  margin-bottom: 40px;
}

.form-container {
  max-width: 1200px;
  margin: 90px auto 20px;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.steps {
  display: flex;
  justify-content: space-between;

  position: relative;
  padding: 0 40px;
  margin-top: 30px;
  margin-bottom: 60px;
}

.step {
  display: flex;
  align-items: center;
  z-index: 1;
}

.step-number {
  width: 24px;
  height: 24px;
  background: #1890ff;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  font-size: 17px;
}

.step-text {
  font-size: 24px;
}

.step::after {
  content: "";
  display: inline-block;
  width: 127px;
  height: 1px;
  z-index: 0;
  margin-left: 6px;
}

.steps .step:last-child:after {
  content: "";
  display: inline-block;
  width: 0;
  height: 0;
  background: #e8e8e8;
  z-index: 0;
  margin-left: 0;
}

.form-row {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-size: 24px;
}

.required::before {
  content: "*";
  color: #ff4d4f;
  margin-right: 4px;
}

.form-input {
  width: 100%;
  padding: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 24px;
}

.radio-group {
  display: flex;
  gap: 20px;
}

.notice {
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 40px;
}

.file-upload {
  border: 1px dashed #d9d9d9;
  padding: 20px;
  text-align: center;
  background: #fafafa;
  border-radius: 4px;
}

.upload-button {
  background: #1890ff;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.file-info {
  font-size: 24px;
  color: #666;
  margin-top: 12px;
}

.file-types {
  font-size: 24px;
  color: #666;
  margin-top: 8px;
}

.form-containerquery {
  max-width: 800px;
  margin: 20px auto;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
}

.required::before {
  content: "*";
  color: #ff4d4f;
  margin-right: 4px;
}

.file-types {
  font-size: 24px;
  color: #666;
  margin-bottom: 20px;
}

.certificate-type {
  border: 1px solid #e8e8e8;
  padding: 15px;
  margin-bottom: 20px;
}

.certificate-warning {
  color: #ff4d4f;
  font-size: 15px;
  margin-bottom: 10px;
}

.certificate-options {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
  margin-bottom: 20px;
}

.certificate-option {
  border: 1px solid #e8e8e8;
  padding: 15px;
  text-align: center;
  cursor: pointer;
  border-radius: 4px;
}

.certificate-option:hover {
  border-color: #40a9ff;
}

.certificate-option.selected {
  border-color: #1890ff;
  background-color: #e6f7ff;
}

.certificate-option img {
  width: 60px;
  height: 60px;
  margin-bottom: 10px;
}

.rights-section {
  margin-bottom: 20px;
}

.rights-grid {
  width: 90%;
  margin: 0 auto;

  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
}

.right-option {
  width: 25%;
  display: flex;
  align-items: center;

  font-size: 24px;
  margin-bottom: 15px;

  input {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }

  label {
    color: #333;
  }
}

.agreement {
  display: flex;
  align-items: center;

  margin-bottom: 20px;
  justify-content: center;

  input {
    width: 16px;
    height: 16px;
  }
}

.agreement a {
  color: #1890ff;
  text-decoration: none;
}

.submit-buttonLeft {
  background: #1890ff;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 24px;
  /* width: 100%; */
  width: 200px;
  text-align: center;
  margin-left: 25%;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

.submit-buttonRight {
  background: #1890ff;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 24px;
  /* width: 100%; */
  width: 200px;
  text-align: center;
  margin-left: 10%;
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}

.submit-button {
}

.submit-button:hover {
  background: #40a9ff;
}

.notice {
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.cha_xun {
  padding: 3.5rem 18.33rem 10.42rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .tips {
    font-size: 1.33rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #232323;
    line-height: 2.25rem;
  }
}

.cha_xun .tips {
  margin-top: 2.08rem;
  padding: 0.92rem 1.92rem 3.25rem;
  background: rgba(39, 130, 255, 0.1);
  border: 1px solid #2782ff;
  border-radius: 0.25rem;
  display: flex;
  align-items: baseline;
}

.cha_xun .tips div[data-v-71571416] {
  font-size: 1.33rem;
  font-weight: 400;
  color: #232323;
  line-height: 2.25rem;
  font-size: 24px;
}

.cha_xun .input_box {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.cha_xun .file_hash[data-v-71571416],
.cha_xun .unified_numbering[data-v-71571416] {
  display: flex;
  align-items: center;
  margin-top: 4.25rem;
}

.cha_xun .file_hash .el-input[data-v-71571416] .el-input__inner,
.cha_xun .unified_numbering .el-input[data-v-71571416] .el-input__inner {
  border-radius: 0.25rem;
  font-size: 1.4rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.cha_xun .query[data-v-71571416] {
  cursor: pointer;
  margin-top: 5.67rem;
  padding: 1.17rem 10rem;
  display: inline-block;
  background: #2782ff;
  box-shadow: 0 0.3rem 3rem 0 rgba(29, 62, 187, 0.2);
  border-radius: 0.25rem;
  font-size: 1.67rem;
  font-weight: 700;
  color: #fff;
  line-height: 2rem;
}

.me {
  max-width: 1200px;
  height: auto;
  margin: 90px auto 90px;
  padding: 20px 0;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

::v-deep .labe2 {
  font-size: 16px;
}

.no_loginLeft {
  cursor: pointer;
  background: #e4e7ed;
  border-radius: 24px;
  font-size: 24px;
  color: #303133;
  line-height: 23px;
  padding: 12px 22px;
  margin-bottom: 30px;
}

.no_loginRight {
  cursor: pointer;
  background: #e4e7ed;
  border-radius: 24px;
  font-size: 24px;
  color: #303133;
  line-height: 23px;
  padding: 12px 22px;
  margin-bottom: 30px;
  margin-left: 10px;
}

.el-dropdownClass {
  width: 50%;
}

.dataclass {
  font-size: 24px;
}

.submitClass {
  display: flex;
}

.el-textarea .el-input__count {
  margin-bottom: 10px !important;
}

.right-optionValue {
  width: 30%;
  display: flex;
  align-items: center;

  font-size: 24px;
  margin-bottom: 15px;

  input {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
}
</style>
